import { RiGithubFill } from '@remixicon/react'
import Link from 'next/link'

interface OpenSourceCTAProps {
  githubStars: number
}

export function OpenSourceCTA({ githubStars }: OpenSourceCTAProps) {
  const formattedGithubStars = githubStars >= 1000
    ? `${(Math.round(githubStars / 100) / 10).toFixed(1)}k`
    : `${githubStars}`

  return (
    <section className="bg-slate-900 py-16 md:py-32 px-4">
      <div className="mx-auto max-w-7xl text-center">
        <h2 className="mt-4 text-4xl font-semibold tracking-tight text-white md:text-7xl">
          Open source. No investors. <br></br>No nonsense.
        </h2>
        <p className="sectionDesc mx-auto !text-slate-300">
          HeyForm is open source and fully bootstrapped — built by its users, not investors.
          No external pressure. No forced decisions. Just a product that works for you.
        </p>
        <div className="mt-20 grid grid-cols-1 gap-8 text-center sm:grid-cols-3">
          {[
            { value: '# 1', label: 'Trending of the Day' },
            { value: formattedGithubStars, label: 'Stars' },
            { value: '100k+', label: 'Deployments' }
          ].map((stat, index) => (
            <div key={index}>
              <div className="text-7xl font-medium text-white mb-2">
                {stat.value}
              </div>
              <div className="text-2xl text-slate-400 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-16 flex justify-center">
          <Link
            className="bg-slate-200 hover:bg-slate-100 text-black font-medium py-3 px-4 rounded-md transition duration-300 ease-in-out inline-block mt-8"
            href="https://github.com/heyform/heyform"
            target="_blank"
          >
            <RiGithubFill className="inline mr-2 h-5 w-5" />
            Check us on GitHub
          </Link>
        </div>
      </div>
    </section>
  )
}
